module.exports = __webpack_public_path__ + "img/120.found_another.3d704422.svg";